exports.images = require('./config/images')



//////////////////
// WEBPACK FOOTER
// ../packages/simplesat-config/index.js
// module id = 283
// module chunks = 13